import { type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { BODY, Bullet, PullQuote, Section } from './rules-typography';

export function CreateIdentity(): ReactNode {
  return (
    <Section title="1. Crea tu identidad de jugador">
      <p className={BODY}>
        Necesitas una cuenta nueva de Instagram, secundaria. La personal no
        sirve.
      </p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Nombre: el que quieras.</Bullet>
        <Bullet>Uso: solo para jugar.</Bullet>
        <Bullet>Objetivo: entrenar el algoritmo.</Bullet>
      </ul>
      <div className="flex items-start gap-sm">
        <AlertTriangle size={16} className="mt-0.5 shrink-0 text-brand-red" />
        <p className={BODY}>
          Jugar con tu cuenta personal te lleva strike directo.
        </p>
      </div>
    </Section>
  );
}

export function TrainAlgorithm(): ReactNode {
  return (
    <Section title="2. Entrena el algoritmo">
      <p className={BODY}>
        Interactúa con publicaciones y creadores que sean match. Es tu arma
        secreta.
      </p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Dale like al post.</Bullet>
        <Bullet>Guárdalo (pesa más que el like).</Bullet>
        <Bullet>
          Sigue solo a creadores que ya están encontrados — por ti o por otro
          jugador.
        </Bullet>
      </ul>
      <PullQuote>
        Si no lo sigues, es nuevo. Si ya lo sigues, ya está encontrado. Menos
        lío, más velocidad, más dinero.
      </PullQuote>
    </Section>
  );
}
